import { AsyncData } from '../core';

export interface DailyShiftSchedule {
  am: ShiftSubschedule;
  editHistory: ScheduleEdit[];
  pm: ShiftSubschedule;
  refreshedAt: Date | null;
}

export interface NotAllowedMatch {
  id: string;
  providerOneId: string;
  providerTwoId: string;
  new: boolean;
}

export interface Doctor extends Provider {
  type: DoctorType;
}

export enum DoctorType {
  Internal = 'IM',
  Family = 'FP',
  Ped = 'PED',
}

export interface LocalDateRange {
  endTime: number;
  startTime: number;
  timeZone: string;
}

export enum MessageStatus {
  Draft = 'draft', // not yet sent
  Sent = 'sent', // sent successfully
  Failed = 'failed', // failed to send
  Confirmed = 'confirmed', // replied
}

export interface Provider {
  id: string;
  marketCode: string | null;
  name: string;
  prefix: string | null;
  suffix: string | null;
  surname: string;
  tags: string[];
}

export interface MAShift extends Provider {
  isOnsite: boolean;
  shiftDateRange: LocalDateRange;
}

export interface ScheduleEdit {
  author: {
    email: string;
  };
  date: Date;
  fieldName: string;
  fromValue: string;
  shiftId: string;
  toValue: string;
}

export interface SchedulingState {
  dailyShiftSchedule: AsyncData<DailyShiftSchedule>;
  pairingRules: AsyncData<NotAllowedMatch[]>;
}

export interface Shift {
  doctor: Doctor | null;
  drConfirmed: boolean;
  drDateRange: LocalDateRange;
  drMessageStatus: MessageStatus;
  id: string;
  isOnsite: boolean;
  ma: MAShift | null;
  maConfirmed: boolean;
  maDateRange: LocalDateRange;
  maMessageStatus: MessageStatus;
  marketCode: string;
  messageSent: boolean;
  positionType: string;
  notes: string;
  submarkets: string[];
  travelApproved: boolean;
}

export interface ShiftSubschedule {
  floatMessages: { [maId: string]: MessageStatus };
  scheduledDoctors: string[];
  scheduledMAs: { [market: string]: MAShift[] }[];
  maNotes: { [maId: string]: string };
  shifts: Shift[];
}
